<ng-template #mapTypeTemplate>
  @if (host().hasMapTypeControl()) {
    <div class="maptype-control">
      @for (mapTypeId of host().mapTypeEntries(); track mapTypeId.key) {
        <button
          type="button"
          [class.selected]="host().currentMapTypeId() === mapTypeId.key"
          [class]="mapTypeId.key"
          (click)="host().setMapTypeId(mapTypeId.key)"
        >
          <span>
            {{ mapTypeId.label }}
          </span>
        </button>
      }
    </div>
  }
</ng-template>

<ng-template #layersTemplate>
  @if (host().layers().length > 0) {
    <div class="layers-control" [class.blurred]="host().isBlurred()">
      <ng-template
        cdkConnectedOverlay
        #overlay="cdkConnectedOverlay"
        [cdkConnectedOverlayOrigin]="dropdownToggle"
        [cdkConnectedOverlayOpen]="host().isLayerSelectorDropdownOpen()"
        (overlayOutsideClick)="host().isLayerSelectorDropdownOpen.set(false)"
        [cdkConnectedOverlayPanelClass]="'cdk-dropdown'"
        [cdkConnectedOverlayPositions]="
          host().layerSelectorCdkOverlayPositionPairs()
        "
      >
        <div class="dropdown-content">
          <ul class="item-list">
            @for (layer of host().layers(); track $index) {
              <li (click)="host().onLayerClick(layer.key)">
                @if (host().selectedLayers().includes(layer.key)) {
                  <i class="material-symbols-rounded">done</i>
                } @else {
                  <span class="check-placeholder"></span>
                }
                {{ layer.label }}
              </li>
            }
          </ul>
        </div>
      </ng-template>
      <button
        type="button"
        cdkOverlayOrigin
        #dropdownToggle="cdkOverlayOrigin"
        (click)="host().toggleLayerSelectorDropdown()"
      >
        <i class="material-symbols-rounded">layers</i>
      </button>
    </div>
  }
</ng-template>

<ng-template #fullScreenTemplate>
  @if (host().hasFullScreenControl()) {
    <div class="fullscreen-control" [class.blurred]="host().isBlurred()">
      <!--
        `nativeElement`, not the `ElementRef`: in the parent's own template `mapContainer`
        resolved to the `#mapContainer` *template reference* (the raw element), which shadowed
        the like-named `@ViewChild` field. That ref is out of scope here, and
        `FullScreenDirective` needs an `HTMLElement` — handed an `ElementRef` it silently does
        nothing, because every `requestFullscreen` branch is undefined on it.
      -->
      <button
        poziFullScreen
        #fullScreen="poziFullScreen"
        [elementToSendFullScreen]="host().mapContainer?.nativeElement"
      >
        <i class="material-symbols-rounded">{{
          fullScreen.isFullscreen() ? 'zoom_in_map' : 'zoom_out_map'
        }}</i>
      </button>
    </div>
  }
</ng-template>

<ng-template #zoomTemplate>
  @if (host().hasZoomControl()) {
    <div class="zoom-control" [class.blurred]="host().isBlurred()">
      <button (click)="host().zoomOut()" class="zoom-control-out">
        <i class="material-symbols-rounded">remove</i>
      </button>
      <span class="line-between-controls"></span>
      <button (click)="host().zoomIn()" class="zoom-control-in">
        <i class="material-symbols-rounded">add</i>
      </button>
    </div>
  }
</ng-template>

<ng-template #routeSpeedTemplate>
  @if (host().hasRouteSpeedControl()) {
    <pozi-route-speed-control
      [class.blurred]="host().isBlurred()"
      [isToggled]="host().isRouteSpeedControlEnabled()"
      (toggleChange)="host().toggleRouteSpeedControl($event)"
    ></pozi-route-speed-control>
  }
</ng-template>

<ng-template #scaleTemplate>
  @if (host().hasScaleControl()) {
    <pozi-scale-control
      [input]="host().scaleControlInput()"
      [class.blurred]="host().isBlurred()"
    ></pozi-scale-control>
  }
</ng-template>

<ng-template #titleTemplate>
  @if (host().hasTitle()) {
    <div [class.white]="host().isBlurred()">
      <span>{{ host().input().title }}</span>
    </div>
  }
</ng-template>

<ng-template #minimizedTimelineTemplate>
  @if (!host().isTimelineDisplayed()) {
    <div class="minimized-timeline" [class.blurred]="host().isBlurred()">
      <button (click)="host().isTimelineDisplayed.set(true)">
        <pozi-toggle
          class="toggle"
          [value]="host().isTimelineDisplayed()"
        ></pozi-toggle>

        <i class="material-symbols-rounded">legend_toggle</i>
      </button>
    </div>
  }
</ng-template>

<ng-template #routerLinkTemplate>
  @if (host().routerLink()) {
    <a [routerLink]="host().routerLink()" [queryParams]="host().queryParams()">
      <i
        class="material-symbols-rounded wght-200 router-link-arrow"
        [class.white]="host().isBlurred()"
        >arrow_back_ios</i
      >
    </a>
  }
</ng-template>
